import Home from './Home';
// import C from './C';
const routes = [
    {
        path: '/',
        component: Home,
        name: 'Home',
        exact: true,
    },
    // {
    //     path: '/example_components',
    //     component: C,
    //     name: 'list',
    //     exact: true,
    // },
];
export default routes;
//# sourceMappingURL=routes.js.map